module.exports = __webpack_public_path__ + "img/underground-belt-structure.9f82b3ca.png";